import { createElement, type JSX } from 'react'

interface ContainerProps {
  className?: string
  children: React.ReactNode
}

type ContainerAllowedInstrinsicElements = keyof Pick<
  JSX.IntrinsicElements,
  'div' | 'footer' | 'section'
>

type IntrinsicProps<T extends ContainerAllowedInstrinsicElements> =
  React.ComponentProps<T> & { as?: T }

const Container = <T extends ContainerAllowedInstrinsicElements = 'div'>({
  as,
  className,
  children,
  ...restProps
}: ContainerProps & IntrinsicProps<T>) => {
  return createElement(
    as ?? 'div',
    {
      className: `flex w-screen justify-center ${className ?? ''}`,
      ...restProps,
    },
    <div className='max-width'>{children}</div>,
  )
}

export default Container
